import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2693a13e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "oplog-header" }, "近期模拟表现", -1))
const _hoisted_2 = {
  key: 1,
  class: "loading-tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: "stock-oplog card",
    style: _normalizeStyle(_ctx.oplogVars)
  }, [
    _hoisted_1,
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      pagination: false,
      rowKey: "idx",
      size: "small",
      locale: _ctx.tableLocale,
      scroll: { y: 260 }
    }, {
      profitRate: _withCtx(({ text }) => [
        _createElementVNode("span", {
          class: _normalizeClass(text > 0 ? 'rise-text' : text < 0 ? 'fall-text' : 'neutral-text')
        }, _toDisplayString(_ctx.formatPctTrunc(text)), 3)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "locale"]),
    (_ctx.total > _ctx.pageSize && _ctx.list.length < _ctx.total)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "load-more",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
        }, " 查看全部 "))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "加载中..."))
      : _createCommentVNode("", true)
  ], 4))
}